import { moment } from '@icedesign/base';

import {
  SET_DASHBOARD_OVERVIEW_DATAS,
  SET_DASHBOARD_MAP_LOCKS,
  SET_DASHBOARD_SWITCH_DATAS,
  SET_DASHBOARD_SETTING_DATAS,
  SET_DASHBOARD_CHART_DATAS,
  SET_DASHBOARD_CHART_DATE_RANGE,
  SET_DASHBOARD_TASKS,
  SET_DASHBOARD_MAP_WORKERS,
  SET_DASHBOARD_AUTHORITYS,
} from '../constants/DashboardConstants';

export const initialState = {
  overviewDatas: {},
  mapLocks: [],
  mapWorkers: [],
  switchDatas: [],
  settingDatas: [],
  chartDateRange: [moment().subtract(6, 'd').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
  chartDatas: [],
  tasks: [],
  authoritys: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_DASHBOARD_OVERVIEW_DATAS: {
      return {
        ...state,
        overviewDatas: action.payload,
      };
    }

    case SET_DASHBOARD_MAP_LOCKS: {
      return {
        ...state,
        mapLocks: action.payload,
      };
    }

    case SET_DASHBOARD_SWITCH_DATAS: {
      return {
        ...state,
        switchDatas: action.payload,
      };
    }

    case SET_DASHBOARD_SETTING_DATAS: {
      return {
        ...state,
        settingDatas: action.payload,
      };
    }

    case SET_DASHBOARD_CHART_DATAS: {
      return {
        ...state,
        chartDatas: action.payload,
      };
    }
    case SET_DASHBOARD_CHART_DATE_RANGE: {
      return {
        ...state,
        chartDateRange: action.payload,
      };
    }

    case SET_DASHBOARD_TASKS: {
      return {
        ...state,
        tasks: action.payload,
      };
    }

    case SET_DASHBOARD_MAP_WORKERS: {
      return {
        ...state,
        mapWorkers: action.payload,
      };
    }

    case SET_DASHBOARD_AUTHORITYS: {
      return {
        ...state,
        authoritys: action.payload,
      };
    }

    default: {
      return state;
    }
  }
}
